<template>
  <div class="obituary-single__hero-text read-more-inline__wrapper">
    <div v-if="!isEditMode && compact">
      <p
        class="obituary-single__hero-intro"
        ref="intro"
        :class="{ 'is-clamped': !showFull }"
        v-text="savedHeroText"
      />
      <button
        class="btn inline-link obituary-single__hero-more"
        type="button"
        v-if="overflows || showFull"
        :aria-expanded="showFull ? 'true' : 'false'"
        @click="toggle"
        v-text="label"
      />
    </div>
    <div v-else-if="!isEditMode">
      <p>
        <span class="obituary-single__hero-text-body" v-text="text" />
        <button
          class="btn inline-link"
          type="button"
          v-if="showReadMore"
          @click="toggle"
          v-text="label"
        />
      </p>
    </div>
    <div v-else>
      <div class="hero-text-edit-wrapper">
        <p
          class="obituary-single__hero-text-edit"
          :key="heroTextResetKey"
          :contenteditable="editText"
          :ref="'heroText'"
          @input="setState({ heroText: $event.target.innerText })"
          v-text="savedHeroText"
        />
      </div>
      <span v-if="isEditMode && editText">
        <button
          class="btn cta btn-sm hero-text-edit"
          type="button"
          v-if="isEditMode && editText"
          :class="{ 'btn-loading': isSavingText }"
          @click.prevent="save"
        >
          <Loader :loading="isSavingText" />
          <span v-text="creatorTexts.save" />
        </button>
        <button class="btn invisible" type="button" @click="reset">
          {{ creatorTexts.cancel }}
        </button>
      </span>
      <button
        class="btn invisible hero-text-edit"
        type="button"
        v-else
        @click="toggleEdit"
      >
        {{ creatorTexts.editText }}
      </button>
    </div>
  </div>
</template>

<script>
  import Loader from "Components/loader/Loader.vue";
  import { mapActions, mapMutations, mapState } from "vuex";
  import { useMediaQuery } from "../composables/useSlideshow";
  import { TRACK_QUERY } from "../highlights/use-swipe-track";

  export default {
    beforeMount() {
      const { fullText } = this.$mountEl.dataset;
      this.setState({ savedHeroText: fullText.replace(/<br\s*[/]?>/gi, "") });
      this.oldText = this.savedHeroText;
    },
    components: {
      Loader,
    },
    computed: {
      ...mapState("creator", [
        "isEditMode",
        "heroText",
        "isSavingText",
        "savedHeroText",
      ]),
      excerpt() {
        return this.savedHeroText.length > 150
          ? this.savedHeroText.slice(0, 125)
          : this.savedHeroText;
      },
      label() {
        return this.showFull ? this.texts.hideText : this.texts.readMore;
      },
      showReadMore() {
        return this.savedHeroText.length > 150;
      },
      text() {
        return this.showFull ? this.savedHeroText : this.excerpt;
      },
    },
    data() {
      return {
        creatorTexts: lavendlaObituary.creator,
        editText: false,
        heroTextResetKey: 0,
        oldText: "",
        overflows: false,
        showFull: false,
        texts: theme_vars.readMore,
      };
    },
    methods: {
      ...mapMutations("creator", ["setState"]),
      ...mapActions("creator", ["saveHeroText"]),
      async measure() {
        await this.$nextTick();
        const { intro } = this.$refs;
        if (intro && !this.showFull) {
          this.overflows = intro.scrollHeight > intro.clientHeight + 1;
        }
      },

      async reset() {
        await this.setState({ savedHeroText: this.oldText });
        this.heroTextResetKey += 1;
        this.editText = false;
      },
      async save() {
        await this.saveHeroText(this.savedHeroText);
        this.oldText = this.savedHeroText;
        this.editText = false;
      },
      toggle() {
        this.showFull = !this.showFull;
      },
      toggleEdit() {
        this.editText = !this.editText;
      },
    },

    mounted() {
      this.measure();
      // The webfont changes how many lines the text takes.
      document.fonts?.ready.then(() => this.measure());
      window.addEventListener("resize", this.measure);
    },
    name: "HeroText",
    setup() {
      // Phones and tablets cut the intro to two lines, so the highlights block sits higher.
      return { compact: useMediaQuery(TRACK_QUERY) };
    },
    watch: {
      compact() {
        this.measure();
      },
      // The text is hidden while editing, so measure it again once it shows.
      isEditMode(editing) {
        if (!editing) {
          this.measure();
        }
      },
      savedHeroText() {
        this.measure();
      },
    },
  };
</script>
